export const LOGIN_ENDPOINT = {
    method: 'POST',
    path: '/api/v1/auth/login',
};
//# sourceMappingURL=login.js.map